export const demoUsers = [
  { UserId: 1, Name: 'Daniel Ekdahl' },
  { UserId: 2, Name: 'Daniel Thim' },
  { UserId: 3, Name: 'Åsa Vallmar' },
  { UserId: 4, Name: 'Kalle Ekelund' },
  { UserId: 5, Name: 'Carl-Johan Nilsson' },
  { UserId: 6, Name: 'Henrik Damgren' },
  { UserId: 7, Name: 'Valdemar Borell' },
  { UserId: 8, Name: 'Josefin Lundgren' },
  { UserId: 9, Name: 'Pär Lindquist' },
];

export const demoStatuses = [
  { StatusId: 1, StatusName: 'Hos kund' },
  { StatusId: 2, StatusName: 'Consid' },
  { StatusId: 3, StatusName: 'Hemma' },
  { StatusId: 4, StatusName: 'Semester' },
  { StatusId: 5, StatusName: 'Sjukskrivning' },
  { StatusId: 6, StatusName: 'Vård av barn' },
  { StatusId: 7, StatusName: 'Röd dag' },
];

export const demoDayInformation = [
  'Städning 07:45–09:00.',
  '',
  'Gemensam aktivitet på kontoret.',
  'Regionsmöte under eftermiddagen.',
  'Veckomöte 12:00–13:00.',
];

export function demoStatusFor(userId, dayIndex) {
  const statusId = ((userId * 3 + dayIndex * 2) % demoStatuses.length) + 1;
  return demoStatuses[statusId - 1];
}
